module.exports = __webpack_public_path__ + "img/f40cfd6.png";